
import { computed, defineComponent } from 'vue'

export default defineComponent({
  name: 'HeadingLv2',

  props: {
    text: String,
    simple: {
      type: Boolean,
      default: false
    },
    bgBlue: {
      type: Boolean,
      default: false
    },
    icon: String,
    caption: String
  },

  setup(props) {
    const classObject = computed(() => {
      return {
        headingLv2: true,
        'headingLv2-simple': props.simple,
        'bg-blue': props.bgBlue,
        'hasCaption': props.caption
      }
    })

    return {
      classObject
    }
  }
})
